// Mock data for Roger Minner Homes clone (frontend-only, browser data)

export const CONTACT = {
  name: "Roger Minner",
  title: "Realtor",
  phone: "610-742-1989",
  phoneRaw: "6107421989",
  email: "rogerminnerhomes@gmail.com",
  address: "247 Longwood Rd, Kennett Square, Pennsylvania 19348",
  area: "Kennett Square, PA serving Greater Chester and Delaware Counties",
  specialist: "Approved Military and Gov't relocation specialist",
};

export const NAV_ITEMS = [
  { label: "Home", path: "/" },
  { label: "Financing", path: "/financing" },
  { label: "Current Listings", path: "/current-listings" },
  { label: "Closed Sales", path: "/closed-sales" },
  { label: "Testimonials", path: "/testimonials" },
  { label: "Contact", path: "/contact" },
];

export const TEAM = [
  {
    id: "roger",
    first: "Roger",
    last: "Minner",
    role: "President Minner Realty / Agent",
    img: "/images/roger.png",
    bio: "Roger joined Real Broker after a long and successful career with the U.S. Department of Homeland Security and The United States Air Force. Having lived locally for most of his life, he has extensive knowledge of the area. Roger offers a unique perspective, skill set and experience that adds tremendous value to his client's real estate experience. Roger serves the Greater Chester and Delaware Counties and has extensive knowledge and experience with both Listings and working with Buyers. In addition, Roger is a Approved Military and Gov't relocation specialist. Please reach out to Roger and Whitney for a remarkable home selling and buying experience.",
  },
  {
    id: "whitney",
    first: "Whitney",
    last: "Dunbar Minner",
    role: "Agent / RDH",
    img: "/images/whitney.png",
    bio: "Whitney brings a thoughtful, detail-driven approach to every client experience. She's committed to providing exceptional service and guiding buyers and sellers through the process with clear communication, professionalism, and care. With a strong work ethic and a calm, confident presence, Whitney helps ensure each transaction feels seamless from start to finish.",
  },
  {
    id: "paige",
    first: "Paige",
    last: "Sorrentino",
    role: "Senior Transaction Coordinator",
    img: "/images/paige.png",
    bio: "Paige graduated from Stockton University in 2021 and spent four years as an elementary school teacher before finding her way into real estate. Now she works as a transaction coordinator, supporting agents and clients through every step of the buying and selling process. She loves being a point of contact for clients—answering questions, keeping them informed, and making sure everything stays on track from contract to close.",
  },
  {
    id: "bill",
    first: "Bill",
    last: "Litton",
    role: "Regional President / Loan Officer",
    img: "/images/bill.jpg",
    bio: "Hi, I'm Bill, dedicated to refining the mortgage process to better serve real estate agents and consumers at our West Chester, PA branch. I start by listening to your goals and offering a home loan that fits your unique situation. Whether you're a first-time homebuyer, investor, or renovating, I'll guide you through options like FHA, VA, conventional, and jumbo loans. Our pre-approval process is the gold standard in Southeastern Pennsylvania and the Tri-State Area, ensuring accurate facts and figures before you commit. With a 100% close ratio on pre-approvals, and a 99.99% satisfaction rate, we make home financing smooth and stress-free.",
  },
  {
    id: "chadd",
    first: "Chadd",
    last: "Ingram",
    role: "Founder & President of Ingram Engineering",
    img: "/images/chadd.jpg",
    bio: "Chadd Ingram is the Founder and President of Ingram Engineering Services, serving Pennsylvania, Delaware, New Jersey, and Maryland with structural engineering, geotechnical engineering, and special inspection services. As a trusted engineering partner to Roger Minner Homes, Chadd and his team help clients navigate projects requiring engineering expertise. Whether addressing a structural, drainage, foundational concern or planning property improvement, Ingram Engineering provides the guidance and approvals needed to bring projects to life.",
  },
  {
    id: "brian",
    first: "Brian",
    last: "Troutner",
    role: "Vice President Global Title, Inc",
    img: "/images/brian.jpg",
    bio: "With 26 years of experience in the title insurance and real estate settlement industry, Brian Troutner and his company Global Title Inc. are licensed Title Agents in Pennsylvania, Maryland, New Jersey, Delaware, and Virginia. Throughout his career, he has successfully handled a wide range of residential and complex commercial real estate transactions, providing clients with knowledgeable guidance and exceptional service from contract through closing. His extensive multi-state expertise, attention to detail, and commitment to facilitating smooth and efficient transactions have earned the trust of Buyers, Sellers, attorneys, lenders, and real estate professionals alike. His company Global Title, Inc. is a family owned company committed to providing exceptional service for clients.",
  },
  {
    id: "hounds",
    first: "June Bug",
    last: "& Bocephus",
    role: "Showing Assistants",
    img: "/images/hounds.jpg",
    bio: "Say hello to our Hounds, June Bug and Bocephus—our four-legged showing assistants! Expert in curb appeal, master of tail wags, and always on the lookout for the perfect place to call home. Specializes in loyalty, comfort, and making every showing feel welcoming.",
  },
];

// Active listings — data and photo sourced from Zillow (listed by Roger Minner).
export const CURRENT_LISTINGS = [
  {
    id: 1,
    status: "For Sale",
    price: "$579,000",
    address: "1731 W Doe Run Rd",
    city: "Kennett Square, PA 19348",
    beds: 3, baths: 3,
    represented: "Listed by Roger Minner",
    img: "/images/listings/doerun.jpg",
    url: "https://www.zillow.com/homedetails/1731-W-Doe-Run-Rd-Kennett-Square-PA-19348/9208736_zpid/",
  },
];

// All seller represented. Data and photos sourced from Zillow listings (listed by Roger Minner).
export const CLOSED_SALES = [
  {
    id: 1, price: "$2,325,000", address: "2619 Chester Springs Rd", city: "Chester Springs, PA 19425",
    beds: 4, baths: 7, represented: "Represented Seller",
    img: "/images/sold/chestersprings.jpg",
    url: "https://www.zillow.com/homedetails/2619-Chester-Springs-Rd-Chester-Springs-PA-19425/2069848958_zpid/",
  },
  {
    id: 2, price: "$715,000", address: "157 Hamilton Rd", city: "Landenberg, PA 19350",
    beds: 4, baths: 4, represented: "Represented Seller",
    img: "/images/sold/hamilton.jpg",
    url: "https://www.zillow.com/homedetails/157-Hamilton-Rd-Landenberg-PA-19350/9208296_zpid/",
  },
  {
    id: 3, price: "$710,000", address: "15 Leopard Run", city: "Glen Mills, PA 19342",
    beds: 4, baths: 3, represented: "Represented Seller",
    img: "/images/sold/leopard.jpg",
    url: "https://www.zillow.com/homedetails/15-Leopard-Run-Glen-Mills-PA-19342/9328018_zpid/",
  },
  {
    id: 4, price: "$624,900", address: "285 Cherry Ln", city: "Kennett Square, PA 19348",
    beds: 3, baths: 3, represented: "Represented Seller",
    img: "/images/sold/cherry.jpg",
    url: "https://www.zillow.com/homedetails/285-Cherry-Ln-Kennett-Square-PA-19348/67355396_zpid/",
  },
  {
    id: 5, price: "$500,000", address: "103 Skyline Dr", city: "Landenberg, PA 19350",
    beds: 4, baths: 2, represented: "Represented Seller",
    img: "/images/sold/skyline.jpg",
    url: "https://www.zillow.com/homedetails/103-Skyline-Dr-Landenberg-PA-19350/54757384_zpid/",
  },
  {
    id: 6, price: "$465,000", address: "101 Federal Walk", city: "Kennett Square, PA 19348",
    beds: 3, baths: 3, represented: "Represented Seller",
    img: "/images/sold/federal.jpg",
    url: "https://www.zillow.com/homedetails/101-Federal-Walk-Kennett-Square-PA-19348/52612942_zpid/",
  },
  {
    id: 7, price: "$410,000", address: "1105 Brinton Place Rd", city: "West Chester, PA 19380",
    beds: 3, baths: 3, represented: "Represented Seller",
    img: "/images/sold/brinton.jpg",
    url: "https://www.zillow.com/homedetails/1105-Brinton-Place-Rd-West-Chester-PA-19380/9193511_zpid/",
  },
];

export const CLOSED_STATS = [
  { value: "13", label: "Sales Last 12 Months" },
  { value: "178", label: "Total Sales" },
  { value: "$218K\u2013$2.3M", label: "Price Range" },
  { value: "$597K", label: "Average Price" },
];

export const TESTIMONIALS = [
  {
    id: 1, name: "The Harrington Family", location: "Kennett Square, PA",
    quote: "Roger made selling our family home an absolute breeze. His knowledge of the local market is unmatched, and he was there for us at every single step. We couldn't have asked for a smoother experience.",
  },
  {
    id: 2, name: "Michael & Dana R.", location: "West Chester, PA",
    quote: "As a military family relocating on short notice, we needed someone who understood the process. Roger's expertise as a relocation specialist took all the stress off our shoulders. Highly recommend!",
  },
  {
    id: 3, name: "Jennifer P.", location: "Chadds Ford, PA",
    quote: "Whitney and Roger are the dream team. Their communication was clear and constant, and they truly cared about finding the right home for us—not just any home. Five stars all the way.",
  },
  {
    id: 4, name: "The Callahans", location: "Downingtown, PA",
    quote: "We interviewed three agents and Roger stood out immediately. He priced our home perfectly and we had multiple offers within a week. Professional, honest, and genuinely kind.",
  },
  {
    id: 5, name: "Steven & Amy L.", location: "Avondale, PA",
    quote: "First-time buyers here, and the whole team walked us through everything with patience. Bill on the financing side got us a great rate. It felt like having family in your corner.",
  },
  {
    id: 6, name: "Robert M.", location: "Greater Delaware County, PA",
    quote: "Roger's background and integrity are second to none. He negotiated hard on our behalf and closed exactly when he said he would. I've already referred him to two colleagues.",
  },
];

// Financing content sourced from the provided Financing Options document
export const FINANCING_INTRO = {
  title: "Financing Options",
  subtitle: "The Litton Team, CrossCountry Mortgage  |  Roger Minner, Minner Realty Group",
};

export const FINANCING_PROGRAMS = [
  {
    id: "va",
    name: "VA Home Loans",
    tagline: "No Loan Limits for Veterans",
    intro:
      "Buy or refi through our VA financing program. We make the dream of homeownership possible for those who've served in the military. No loan limits mean more purchasing power for you!",
    groups: [
      {
        heading: "Easy Requirements",
        items: [
          "Credit scores as low as 580",
          "No down payment or mortgage insurance",
          "Condos, townhouses, single-family homes, 2-4 unit income properties",
        ],
      },
      {
        heading: "Outstanding Benefits",
        items: [
          "100% financing, 30-year fixed rates",
          "Closing cost credits available",
          "Funding fee waived with a 10% VA disability or greater",
          "You can reuse your VA eligibility",
        ],
      },
    ],
    cta: "Get the benefits you deserve with a VA home loan. Call or email today!",
  },
  {
    id: "bridge",
    name: "Bridge Loan",
    tagline: "Buy Before You Sell",
    intro:
      "You've found the perfect new home, but you have to sell your current one first. Or do you? Use our Bridge Loan to borrow against your current home to finance the new one. As a bonus, you can make a stronger purchase offer by removing the sale contingency.",
    groups: [
      {
        heading: "Features",
        items: [
          "Primary residences in most states",
          "4-month loan term",
          "No payments collected during Bridge Loan term",
          "Loan amounts: $50,000 – $700,000 (up to 85% loan-to-value)",
          "No appraisal (requires Broker Price Opinion)",
        ],
      },
      {
        heading: "Requirements",
        items: [
          "Finance new property with CrossCountry Mortgage",
          "Close Bridge Loan simultaneously with new purchase",
          "Minimum credit score 680",
        ],
      },
    ],
    cta: "Call or email today!",
  },
  {
    id: "usda",
    name: "USDA Rural Development Loan",
    tagline: "Wide Open Spaces, No Down Payment",
    intro:
      "Get away from it all with a 0%-down USDA Rural Development Loan. A USDA loan can be your path to peace and tranquility. Whether you're purchasing your first home or refinancing your current loan, your best interests and long-term financial success will always be our top priority.",
    groups: [
      {
        heading: "Rural Life Has Its Advantages",
        items: [
          "Helps people in rural and some suburban areas",
          "100% financing, no down payment",
          "Low to moderate income applicants are welcome",
          "30-year fixed rates, purchase or refi",
          "Condo, townhouse & single-family homes eligible in designated rural areas",
          "Seller can contribute up to 6% of sale price toward closing costs",
        ],
      },
    ],
    cta: "Contact me today to find out what's possible with a USDA loan.",
  },
  {
    id: "fha",
    name: "FHA Loans",
    tagline: "Homeownership Is Possible",
    intro:
      "At CCM, we believe everyone deserves a place to call home, and it's our goal to get you the loan you want and the loan you deserve. We do that by understanding each specific situation and finding the perfect fit — even when you have a lower credit score, even as low as 500!",
    groups: [
      {
        heading: "How to Qualify for Your FHA Loan",
        items: [
          "Credit score between 500–579",
          "Minimum 10% down payment",
          "Must have eligible AUS approval",
        ],
      },
    ],
    cta: "Call me today to get started!",
  },
  {
    id: "conventional",
    name: "Conventional Loans",
    tagline: "As a Homebuyer, You Have Options",
    intro:
      "Our conventional loans offer competitive rates plus a variety of choices for terms and down payments. We'll structure the right mortgage to help you achieve your homeownership goals and close as quickly as possible.",
    groups: [
      {
        heading: "Fixed-Rate Mortgages",
        items: [
          "Ideal if you'll live in the home long-term",
          "Interest rate doesn't change, for stable monthly payments",
          "Down payments as low as 3%",
          "No mortgage insurance with 20% down or more",
          "Repayment terms from 10 to 30 years",
        ],
      },
      {
        heading: "Adjustable-Rate Mortgages (ARMs)",
        items: [
          "Ideal if you'll move after a few years",
          "Initial payment may be lower than a fixed-rate mortgage",
          "Rate is fixed for 3, 5, 7, or 10 years, then becomes variable",
          "Set caps to protect against significant rate increases",
          "Repayment terms from 10 to 30 years",
        ],
      },
    ],
    cta: "Ready to get started? Let's connect today!",
  },
];

export const FINANCING_PORTFOLIO = [
  {
    heading: "Standard Programs",
    items: [
      ["Conventional", "Fixed and adjustable-rate mortgages with flexible terms. Best for those who can pay 3% or more down."],
      ["FHA", "Down payments as low as 3.5% and higher DTI limits—great for less-than-perfect credit."],
      ["VA", "100% financing with no down payment for Service Members and Military Families."],
      ["USDA", "Offers rural homeowners up to 100% financing."],
      ["Jumbo", "As little as 10% down and no mortgage insurance on high-cost homes."],
    ],
  },
  {
    heading: "Specialty Agency Programs",
    items: [
      ["Bye-Bye PMI", "Put just 15% down without paying mortgage insurance."],
      ["LLPA Waivers", "More affordable options for qualified first-time and rural buyers."],
      ["ADU", "Use ADU rental income to qualify or consolidate construction costs."],
      ["Student Loan Cash-Out", "Use home equity to pay down student loan debt."],
    ],
  },
  {
    heading: "Construction & Renovation",
    items: [
      ["One-Time-Close Construction", "Combine lot purchase and building costs; lock the rate up front."],
      ["Renovation Loans", "Include mortgage financing and renovation costs in one loan."],
      ["Renovation HELOC", "Borrow up to 125% of current value to finance improvements."],
    ],
  },
  {
    heading: "Down Payment Assistance",
    items: [
      ["CCM Smart Start", "Covers 2% (up to $5,250) for first-time homebuyers."],
      ["The National", "4% assistance as a 30-year fixed interest-only second mortgage."],
      ["Chenoa & Essex", "Pairs with FHA; 3.5% or 5% assistance as a repayable second."],
      ["HFA Programs", "Partnered with 60+ housing finance agencies for affordable options."],
    ],
  },
];

export const FINANCING_CONTACTS = [
  {
    name: "Bill Litton",
    role: "Regional President — The Litton Team, CrossCountry Mortgage",
    lines: [
      "NMLS 147060  |  Branch NMLS 2340315",
      "Office: 484.352.4151  |  Mobile: 302.540.7650",
      "Email: bill.litton@ccm.com",
      "6 Dickinson Drive, Unit 213, Chadds Ford, PA 19317",
    ],
  },
  {
    name: "Roger Minner",
    role: "Minner Realty Group  |  real Broker, LLC  |  real Military",
    lines: [
      "License# RS337176",
      "Office: 855.450.0442  |  Mobile: 610.742.1989",
      "Email: rogerminnerhomes@gmail.com",
      "500 W Office Center Drive, Fort Washington, PA 19034",
    ],
  },
];

export const FINANCING_DISCLAIMER =
  "Equal Housing Opportunity. All loans subject to underwriting approval. Certain restrictions apply. Call for details. All borrowers must meet minimum credit score, loan-to-value, debt-to-income, and other requirements to qualify for any mortgage program. CrossCountry Mortgage, LLC NMLS3029 (www.nmlsconsumeraccess.org). CrossCountry Mortgage, LLC is not affiliated with, or acting on behalf of or at the direction of, any government agency.";
